import { gql } from 'graphql-request';

export const UPDATE_PAYMENT_OPTIONS = gql`
  mutation CoreOrganizationPaymentOptions(
    $input: core_OrganizationPaymentOptionsMutationNS_updateInputInput!
    $id: ID!
  ) {
    coreOrganizationPaymentOptions {
      update(input: $input, id: $id) {
        id
        name
        isDefault
        accountNumber
        corrNumber
        bic
        currency
        docId
        bank {
          id
          name
          status
          type
          countryCode
          createdAt
          updatedAt
          attributes {
            name
            value
          }
        }
      }
    }
  }
`;
